import { render, staticRenderFns } from "./accountManageifno.vue?vue&type=template&id=0c479198&scoped=true&"
import script from "./accountManageifno.vue?vue&type=script&lang=js&"
export * from "./accountManageifno.vue?vue&type=script&lang=js&"
import style0 from "./accountManageifno.vue?vue&type=style&index=0&id=0c479198&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c479198",
  null
  
)

export default component.exports